import React from 'react';
import AdminHeader from '../../globals/Layout/Admin/AdminHeader';
import TCategory from './Tables/TCategory';
const Category: React.FC = () => {
    return (
        <div>
            <AdminHeader>Categorías</AdminHeader>  
            <TCategory/>        
        </div>

    );
};


export default Category;